import { render, staticRenderFns } from "./informatsioon_kastid.vue?vue&type=template&id=41e99802&"
import script from "./informatsioon_kastid.vue?vue&type=script&lang=js&"
export * from "./informatsioon_kastid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports